var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeetingRoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill_out_line",
    "data-name": "Fill out line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m104 24h304v32h-304z",
    fill: "#68737f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 56h256v168h-256z",
    fill: "#d4e4f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 256h208v152h-208z",
    fill: "#ba8b5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 336h-96v-104h32v56h64z",
    fill: "#529ddf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 288h16v24h-16z",
    fill: "#4384c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 336h16v32h-16z",
    fill: "#4f5761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 392a8.00008 8.00008 0 0 1 -8-8v-8h-32v8a8 8 0 0 1 -16 0v-16a8.00008 8.00008 0 0 1 8-8h48a8.00008 8.00008 0 0 1 8 8v16a8.00008 8.00008 0 0 1 -8 8z",
    fill: "#68737f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 320h96v16h-96z",
    fill: "#4384c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 408h32v80h-32z",
    fill: "#9f764a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328 408h32v80h-32z",
    fill: "#9f764a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#68737f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184 352h48v32h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184 256h48v32h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280 352h48v32h-48z",
    transform: "matrix(-1 0 0 -1 608 736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280 256h48v32h-48z",
    transform: "matrix(-1 0 0 -1 608 544)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m120 440h-96v-104h32v56h64z",
    fill: "#529ddf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 392h16v24h-16z",
    fill: "#4384c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 424h96v16h-96z",
    fill: "#4384c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 336h96v-104h-32v56h-64z",
    fill: "#529ddf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 288h16v24h-16z",
    fill: "#4384c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 336h16v32h-16z",
    fill: "#4f5761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 392a8.00008 8.00008 0 0 0 8-8v-8h32v8a8 8 0 0 0 16 0v-16a8.00008 8.00008 0 0 0 -8-8h-48a8.00008 8.00008 0 0 0 -8 8v16a8.00008 8.00008 0 0 0 8 8z",
    fill: "#68737f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 320h96v16h-96z",
    fill: "#4384c3",
    transform: "matrix(-1 0 0 -1 880 656)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 440h96v-104h-32v56h-64z",
    fill: "#529ddf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 392h16v24h-16z",
    fill: "#4384c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 424h96v16h-96z",
    fill: "#4384c3",
    transform: "matrix(-1 0 0 -1 880 864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 248h-16v16h8v136h-192v-136h8v-16h-16a8.00008 8.00008 0 0 0 -8 8v232a8.00008 8.00008 0 0 0 8 8h32a8.00008 8.00008 0 0 0 8-8v-72h128v72a8.00008 8.00008 0 0 0 8 8h32a8.00008 8.00008 0 0 0 8-8v-232a8.00008 8.00008 0 0 0 -8-8zm-184 232h-16v-64h16zm160 0v-64h16v64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 384h-56v-48a8.00008 8.00008 0 0 0 -8-8h-32a8.00008 8.00008 0 0 0 -8 8v104a8.00008 8.00008 0 0 0 8 8h40v16h-16a8.00008 8.00008 0 0 0 -8 8v16a8 8 0 0 0 16 0v-8h32v8a8 8 0 0 0 16 0v-16a8.00008 8.00008 0 0 0 -8-8h-16v-16h40a8.00008 8.00008 0 0 0 8-8v-48a8.00008 8.00008 0 0 0 -8-8zm-8 48h-80v-88h16v72h16v-16h48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 280h-56v-48a8.00008 8.00008 0 0 0 -8-8h-32a8.00008 8.00008 0 0 0 -8 8v80h16v-72h16v72h16v-16h48v32h-32v16h40a8.00008 8.00008 0 0 0 8-8v-48a8.00008 8.00008 0 0 0 -8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488 328h-32a8.00008 8.00008 0 0 0 -8 8v48h-56a8.00008 8.00008 0 0 0 -8 8v48a8.00008 8.00008 0 0 0 8 8h40v16h-16a8.00008 8.00008 0 0 0 -8 8v16a8 8 0 0 0 16 0v-8h32v8a8 8 0 0 0 16 0v-16a8.00008 8.00008 0 0 0 -8-8h-16v-16h40a8.00008 8.00008 0 0 0 8-8v-104a8.00008 8.00008 0 0 0 -8-8zm-8 104h-80v-32h48v16h16v-72h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488 224h-32a8.00008 8.00008 0 0 0 -8 8v48h-56a8.00008 8.00008 0 0 0 -8 8v48a8.00008 8.00008 0 0 0 8 8h40v-16h-32v-32h48v16h16v-72h16v72h16v-80a8.00008 8.00008 0 0 0 -8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 352v32a8.00008 8.00008 0 0 0 8 8h48a8.00008 8.00008 0 0 0 8-8v-32a8.00008 8.00008 0 0 0 -8-8h-19.05566l-13.78907-27.57812a7.99967 7.99967 0 0 0 -7.15527-4.42188h-16v16h11.05566l8 16h-11.05566a8.00008 8.00008 0 0 0 -8 8zm16 8h32v16h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 256a8.00008 8.00008 0 0 0 -8-8h-19.05566l-13.78907-27.57812a7.99967 7.99967 0 0 0 -7.15527-4.42188h-16v16h11.05566l8 16h-11.05566a8.00008 8.00008 0 0 0 -8 8v32a8.00008 8.00008 0 0 0 8 8h48a8.00008 8.00008 0 0 0 8-8zm-16 24h-32v-16h32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336 328v-16h-16a7.99967 7.99967 0 0 0 -7.15527 4.42188l-13.78907 27.57812h-19.05566a8.00008 8.00008 0 0 0 -8 8v32a8.00008 8.00008 0 0 0 8 8h48a8.00008 8.00008 0 0 0 8-8v-32a8.00008 8.00008 0 0 0 -8-8h-11.05566l8-16zm-16 48h-32v-16h32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336 232v-16h-16a7.99967 7.99967 0 0 0 -7.15527 4.42188l-13.78907 27.57812h-19.05566a8.00008 8.00008 0 0 0 -8 8v32a8.00008 8.00008 0 0 0 8 8h48a8.00008 8.00008 0 0 0 8-8v-32a8.00008 8.00008 0 0 0 -8-8h-11.05566l8-16zm-16 48h-32v-16h32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 216h64v16h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 216h-24v-152h240v152h-24v16h32a8.00008 8.00008 0 0 0 8-8v-160h16a8.00008 8.00008 0 0 0 8-8v-32a8.00008 8.00008 0 0 0 -8-8h-304a8.00008 8.00008 0 0 0 -8 8v32a8.00008 8.00008 0 0 0 8 8h16v160a8.00008 8.00008 0 0 0 8 8h32zm-48-184h288v16h-288z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRoom);
export default __webpack_public_path__ + "static/media/meeting-room.de348228716aadfbc3a47cd3f6584061.svg";
export { ForwardRef as ReactComponent };